// index.js

/**
 * "Now I say to you that you are Peter [rock], and upon this rock, I will build my church,
 * and all the powers of hell will not conquer it"
 *
 * Matthew 16:18
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Initialize localStorage defaults for the app
function initializeAppDefaults() {
  const SIDEBAR_KEY = "traces:sidebar:expanded";
  const HOVER_KEY = "traces:sidebar:hover";

  // Only set if not already present (preserves user's previous choice)
  if (localStorage.getItem(SIDEBAR_KEY) === null) {
    localStorage.setItem(SIDEBAR_KEY, "true"); // Default to expanded
  }
  
  if (localStorage.getItem(HOVER_KEY) === null) {
    localStorage.setItem(HOVER_KEY, "false"); // Default hover to false
  }
}

// Initialize defaults before rendering
if (typeof window !== "undefined") {
  initializeAppDefaults();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
